// 生成UUID
const uuid = () => {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4";
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
  s[8] = s[13] = s[18] = s[23] = "-";
  return s.join("");
}

const GUID = () => {
  this.date = new Date();

  /* 判断是否初始化过，如果初始化过以下代码，则以下代码将不再执行，实际中只执行一次 */
  if (typeof this.newGUID != 'function') {

    /* 生成GUID码 */
    GUID.prototype.newGUID = function () {
      this.date = new Date();
      var guidStr = '';
      sexadecimalDate = this.hexadecimal(this.getGUIDDate(), 16);
      sexadecimalTime = this.hexadecimal(this.getGUIDTime(), 16);
      for (var i = 0; i < 9; i++) {
        guidStr += Math.floor(Math.random() * 16).toString(16);
      }
      guidStr += sexadecimalDate;
      guidStr += sexadecimalTime;
      while (guidStr.length < 32) {
        guidStr += Math.floor(Math.random() * 16).toString(16);
      }
      return this.formatGUID(guidStr);
    }

    /*
     * 功能：获取当前日期的GUID格式，即8位数的日期：19700101
     * 返回值：返回GUID日期格式的字条串
     */
    GUID.prototype.getGUIDDate = function () {
      return this.date.getFullYear() + this.addZero(this.date.getMonth() + 1) + this.addZero(this.date.getDay());
    }

    /*
     * 功能：获取当前时间的GUID格式，即8位数的时间，包括毫秒，毫秒为2位数：12300933
     * 返回值：返回GUID日期格式的字条串
     */
    GUID.prototype.getGUIDTime = function () {
      return this.addZero(this.date.getHours()) + this.addZero(this.date.getMinutes()) + this.addZero(this.date.getSeconds()) +
        this.addZero(parseInt(this.date.getMilliseconds() / 10));
    }

    /*
     * 功能: 为一位数的正整数前面添加0，如果是可以转成非NaN数字的字符串也可以实现
     * 参数: 参数表示准备再前面添加0的数字或可以转换成数字的字符串
     * 返回值: 如果符合条件，返回添加0后的字条串类型，否则返回自身的字符串
     */
    GUID.prototype.addZero = function (num) {
      if (Number(num).toString() != 'NaN' && num >= 0 && num < 10) {
        return '0' + Math.floor(num);
      } else {
        return num.toString();
      }
    }

    /*
     * 功能：将y进制的数值，转换为x进制的数值
     * 参数：第1个参数表示欲转换的数值；第2个参数表示欲转换的进制；第3个参数可选，表示当前的进制数，如不写则为10
     * 返回值：返回转换后的字符串
     */
    GUID.prototype.hexadecimal = function (num, x, y) {
      if (y != undefined) {
        return parseInt(num.toString(), y).toString(x);
      } else {
        return parseInt(num.toString()).toString(x);
      }
    }

    /*
     * 功能：格式化32位的字符串为GUID模式的字符串
     * 参数：第1个参数表示32位的字符串
     * 返回值：标准GUID格式的字符串
     */
    GUID.prototype.formatGUID = function (guidStr) {
      var str1 = guidStr.slice(0, 8) + '-',
        str2 = guidStr.slice(8, 12) + '-',
        str3 = guidStr.slice(12, 16) + '-',
        str4 = guidStr.slice(16, 20) + '-',
        str5 = guidStr.slice(20);
      return str1 + str2 + str3 + str4 + str5;
    }
  }
}

// 检查手机号是否合法
const checkPhone = (phone) => {
  var partten = /^(13[0-9]|14[5-9]|15[012356789]|16[5-7]|17[0-8]|18[0-9]|19[135689])[0-9]{8}$/;
  if (partten.test(phone)) {
    return true;
  } else {
    return false;
  }
}

// 严格检查身份证号是否合法
const checkIdCard = (idCard) => {
  //检查身份证号码
  let reg = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/;
  let city = {
    11: "北京",
    12: "天津",
    13: "河北",
    14: "山西",
    15: "内蒙古",
    21: "辽宁",
    22: "吉林",
    23: "黑龙江 ",
    31: "上海",
    32: "江苏",
    33: "浙江",
    34: "安徽",
    35: "福建",
    36: "江西",
    37: "山东",
    41: "河南",
    42: "湖北 ",
    43: "湖南",
    44: "广东",
    45: "广西",
    46: "海南",
    50: "重庆",
    51: "四川",
    52: "贵州",
    53: "云南",
    54: "西藏 ",
    61: "陕西",
    62: "甘肃",
    63: "青海",
    64: "宁夏",
    65: "新疆",
    71: "台湾",
    81: "香港",
    82: "澳门",
    91: "国外 "
  };
  let pass = true;
  if (!idCard || !reg.test(idCard)) {
    pass = false;
  } else if (!city[idCard.substr(0, 2)]) {
    pass = false;
  } else {
    //18位身份证需要验证最后一位校验位
    if (idCard.length == 18) {
      idCard = idCard.split('');
      //加权因子
      var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      //校验位
      var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
      var parity1 = [1, 0, 'x', 9, 8, 7, 6, 5, 4, 3, 2];
      var sum = 0;
      var ai = 0;
      var wi = 0;
      for (var i = 0; i < 17; i++) {
        ai = idCard[i];
        wi = factor[i];
        sum += ai * wi;
      }
      if (parity[sum % 11] != idCard[17] && parity1[sum % 11] != idCard[17]) {
        pass = false;
      }
    }
  }
  return pass;
}

// 简单检查身份证号是否合法
const checkIdCardSimple = (idCard) => {
  if (idCard.length === 0) {
    return false;
  }
  var idCardRegex_18 = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
  var idCardRegex_15 = /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$/;
  return idCardRegex_18.test(idCard) || idCardRegex_15.test(idCard);
}

const int2Boolean = (s) => {
  return s == 1 ? true : false;
}

const boolean2Int = (b) => {
  return b ? 1 : 0;
}


// 通过数组中对象的某个字段对数组进行分组
const groupArray = (array, groupKey) => {
  let result = {};
  for (let i = 0; i < array.length; i++) {
    let obj = array[i];
    if (obj[groupKey]) {
      result[obj[groupKey]] = [];
    }
  }
  for (let key in result) {
    for (let j = 0; j < array.length; j++) {
      let obj2 = array[j];
      if (obj2[groupKey] && key == obj2[groupKey]) {
        result[key].push(obj2);
      }
    }
  }
  return result;
}

// 属性数据构建成数据结构
const buildTree = (list, parentId, idKey = "id", parentIdKey = "parentId") => {
  let result = [];
  if (!list) {
    return result;
  }
  for (let i = 0; i < list.length; i++) {
    if (list[i][parentIdKey] === parentId) {
      let children = buildTree(list, list[i][idKey], idKey, parentIdKey);
      if (children) {
        list[i].children = children;
      }
      result.push(list[i]);
    }
  }
  return result;
}

// 去除html文本中的标签
const replaceHtmlTag = (str) => {
  if (!str) {
    return '';
  }
  let htmlRegex = /<\/?.+?>/g;
  str = str.replace(htmlRegex, '');
  let blankRegex = /^\s*|\s*/;
  str = str.replace(blankRegex, '');
  return str.replace('&nbsp;', ' ');
};

const isWps = (format) => {
  const formats = [
    'xls', 'xlsx', 'doc', 'docx', 'dotx', 'ppt', 'pptx', 'pdf'
  ];
  let result = formats.some((item) => {
    return item === format
  });
  return result;
}

const secondToMinute = (value) => {
  var result = parseInt(value)
  var h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
  var m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
  var s = Math.floor((result % 60)) < 10 ? Math.floor((result % 60)) : Math.floor((result % 60));

  if (s == 0) {
    s = '00'
  } else if (s < 10) {
    s = '0' + s
  }
  var res = '';
  if (h !== '00') res += h + ':';
  if (m !== '00') res += m + ':';
  res += s;
  return res;
}
const cutStr = (str, len) => {
  if (str == null || str == undefined || str == "undefined") {
    return ""
  }
  if (str.length > len) {
    return str.substring(0, len) + '...';
  }
  return str;
}

export default {
  uuid,
  checkPhone,
  checkIdCard,
  checkIdCardSimple,
  int2Boolean,
  boolean2Int,
  groupArray,
  buildTree,
  replaceHtmlTag,
  isWps,
  secondToMinute,
  cutStr,
  GUID,
}



// WEBPACK FOOTER //
// ./src/utils/util.js